import Immutable from 'immutable';
import {Colors} from "../style/colors";
import dayjs from "dayjs";

export const simCardStatus = {
    retired: 'retired',
    activated: 'activated',
    available: 'available',
    deactivated: 'deactivated'
}
export const simCardStatusColor = {
    [simCardStatus.retired]: Colors.lightRed,
    [simCardStatus.activated]: Colors.green,
    [simCardStatus.available]: Colors.blue,
    [simCardStatus.deactivated]: Colors.gray30
}
export const simCardBilled = {
    [simCardStatus.retired]: false,
    [simCardStatus.activated]: true,
    [simCardStatus.available]: false,
    [simCardStatus.deactivated]: true
}

const SimCardModel = Immutable.Record({
    id: 0,
    iccid: '',
    phone: '+',
    status: '',
    notes: '',
    accountManagerId: 0,
    accountManagerName: '',
    deviceId: 0,
    deviceName: '',
    communicationPlan: '',
    jasper: '',

    deactivationDate: null,
    activationDate: null,
    retirementDate: null
});

export default class SimCard extends SimCardModel {
    id: number;
    iccid: string;
    phone: string;
    status: string;
    notes: string;
    accountManagerId: number;
    accountManagerName: string;
    deviceId: number;
    deviceName: string;
    communicationPlan: string;
    jasper: string;
    
    deactivationDate: dayjs;
    activationDate: dayjs;
    retirementDate: dayjs;
    
    get isRetired() {
        return this.status === simCardStatus.retired;
    }
    get isActivated() {
        return this.status === simCardStatus.activated;
    }
    get isAvailable() {
        return this.status === simCardStatus.available;
    }
    get isDeactivated() {
        return this.status === simCardStatus.deactivated;
    }

    filterString() {
        return [
            this.notes,
            this.accountManagerName,
            this.deviceName,
            this.iccid,
            this.jasper,
            this.phone
        ].join('').lc();
    }
}
